import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

const Footer = () => {
  return (
    <>
      <div>
        {/* <div class="section full mt-2 d-block d-md-none"> */}
        <div class="appBottomMenu">
          <Link to="/updates" class="item text-secondary">
            <div class="col d-flex justify-content-center align-items-center flex-column">
              <ion-icon name="albums-outline"></ion-icon>
              <strong>Updates</strong>
            </div>
          </Link>
          <Link to="/timeline" class="item text-secondary">
            <div class="col">
              <ion-icon name="hourglass-outline"></ion-icon>
              <strong>Timeline</strong>
            </div>
          </Link>
          <Link to="/documents" class="item">
            <div class="col">
              <ion-icon name="document-attach-outline"></ion-icon>
              <strong>Documents</strong>
            </div>
          </Link>
          <Link to="/poll" class="item">
            <div class="col">
              <ion-icon name="analytics-outline"></ion-icon>
              <strong>Polls</strong>
            </div>
          </Link>
          <Link to="/forms" class="item">
            <div class="col">
              <ion-icon name="document-outline"></ion-icon>
              <strong>Forms</strong>
            </div>
          </Link>
          {/* <Link to="/website" class="item">
            <div class="col">
              <ion-icon name="globe-outline"></ion-icon>
              <strong>Website</strong>
            </div>
          </Link> */}
        </div>
      </div>
      {/* </div>    */}
    </>
  )
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
